"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get the value of the given key
 *
 * @param  {ObjectInterface} object
 * @param  {string} key
 * @param  {any} $default
 * @returns any
 */
function get(object, key, $default) {
    if ($default === void 0) { $default = null; }
    try {
        var value = key.split('.').reduce(function (obj, property) { return obj[property]; }, object);
        return undefined === value ? $default : value;
    }
    catch (err) {
        return $default;
    }
}
exports.default = get;
//# sourceMappingURL=get.js.map